export function Exit(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" fill="none">
      <path
        fill="#D44A74"
        d="m12.396 21.334 2.291 2.291 8.126-8.125-8.125-8.125-2.292 2.291 4.193 4.209H.875v3.25h15.714l-4.193 4.209ZM26.875.875H4.125a3.25 3.25 0 0 0-3.25 3.25v6.5h3.25v-6.5h22.75v22.75H4.125v-6.5H.875v6.5a3.25 3.25 0 0 0 3.25 3.25h22.75a3.26 3.26 0 0 0 3.25-3.25V4.125a3.26 3.26 0 0 0-3.25-3.25Z"
      />
    </svg>
  );
}
